import { BILLING_NEW_ALERTS_FLOW } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useGetPlanDebtDataQuery } from 'domains/Billing/BillingPlans/billingPlansApi';
import useGetUserInfo from '../useGetUserInfo';
import useStoreStatus from '../useStoreStatus';

function useGetPlanDebt(initialFetch = true) {
  const { storeStatus } = useStoreStatus();

  const userInfo = useGetUserInfo();

  const [isNewAlertsFlow] = useHasTags(BILLING_NEW_ALERTS_FLOW);
  const {
    data: planDebtData,
    isSuccess,
    isError,
  } = useGetPlanDebtDataQuery(undefined, {
    skip: !isNewAlertsFlow || !initialFetch,
  });

  /**
   * We currently don't have the necessary data to check if the store is disabled manually
   * We hardcode the value to false for now and show the user the store locked page for this case
   *  */
  const isStoreDisabledManually = false;

  const isAdminDisabled = storeStatus === 'admin_down';
  const isStoreDisabled =
    !isStoreDisabledManually && storeStatus === 'store_down';

  return {
    planDebtData,
    isSuccess,
    shouldUseDebtData: isNewAlertsFlow && !isError,
    isAdminDisabled,
    isStoreDisabled,
    isStoreDisabledManually,
    shouldShowAdminLock:
      !userInfo?.isEmployee &&
      (isAdminDisabled || isStoreDisabled || isStoreDisabledManually),
  };
}
export default useGetPlanDebt;
